<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1>{{ translate.instant('SiteSettings') }}</h1>
    </mat-toolbar>

    <div class="search-bar">
        <mat-form-field class="search-input" appearance="outline">
            <mat-label>{{ 'Search' | translate: {Default: 'Search'} }}</mat-label>
            <input matInput [(ngModel)]="searchText" autocomplete="off">
            <mat-icon class="material-icons-outlined" matPrefix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="container">
        <ng-container *ngFor="let section of filteredNavList; trackBy: trackBySectionLink">
            <ng-container *appHasModuleAccess="section?.module">
                <mat-card
                    [routerLink]="section.link"
                    class="mat-elevation-z0 primaryHoverColor"
                    *appHasFeature="section.featureCode"
                    setColor
                    [setColorRules]="[
                        {
                            color: 'primaryColour',
                            style: 'border-color'
                        },
                        {
                            color: 'primaryColour',
                            style: 'background-color',
                            events: ['hover']
                        }
                    ]"
                >
                    <div class="icon-div">
                        <span setColor="primaryColour" class="material-icons-outlined">
                            {{ section.icon }}
                        </span>
                    </div>

                    <div class="text">
                        <mat-card-title class="header">
                            {{ translate.instant(section.text) }}
                        </mat-card-title>
                    </div>
                </mat-card>
            </ng-container>
        </ng-container>

        <div class="no-results" *ngIf="filteredNavList.length === 0">
            {{ 'NoSiteSettingsResultsFound' | translate: {Default: 'No matching settings found'} }}
        </div>
    </div>

</app-layout>